"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUsersLoadingError = removeUsersLoadingError;
exports.fetchUsers = fetchUsers;
exports.fetchUsersIfNeeded = fetchUsersIfNeeded;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _UsersApiClient = _interopRequireDefault(require("lead-flows-ui/api/UsersApiClient"));

var _Users = require("lead-flows-ui/selectors/Users");

function requestUsers() {
  return {
    type: _ActionTypes.REQUEST_USERS
  };
}

function recieveUsers(users) {
  return {
    type: _ActionTypes.RECEIVE_USERS,
    payload: users
  };
}

function errorRetrievingUsers(error) {
  return {
    type: _ActionTypes.ERROR_RETRIEVING_USERS,
    payload: error,
    error: true
  };
}

function removeUsersLoadingError() {
  return {
    type: _ActionTypes.REMOVE_USERS_LOADING_ERROR
  };
}

function fetchUsers() {
  return function (dispatch) {
    dispatch(requestUsers());
    return _UsersApiClient.default.fetchUsers().then(function (response) {
      dispatch(recieveUsers(response));
    }, function (error) {
      dispatch(errorRetrievingUsers(error));
    }).done();
  };
}

function fetchUsersIfNeeded() {
  return function (dispatch, getState) {
    var requestState = (0, _Users.getUsersRequestState)(getState());

    if (!requestState.shouldBeRequested()) {
      return;
    }

    dispatch(fetchUsers());
  };
}